module.exports = __webpack_public_path__ + "img/64.ea16a700.jpg";